import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom-v5-compat'

import { useGetOrganization } from '@/app/module/user/hooks/use-get-organization'
import { selectOrgId } from '@/app/module/user/store/selectors'

const EmptyAccountBanner: React.FC = () => {
  const orgId = useSelector(selectOrgId)
  const { currentData: organization, isFetching, isSuccess } = useGetOrganization(orgId)

  const isNewAccount =
    !!orgId && isSuccess && !isFetching && organization?.campaigns === 0 && organization?.contacts === 0
  if (!isNewAccount) {
    return null
  }

  return (
    <Box mb={3} data-testid="empty-account-banner">
      <Card sx={{ background: '#e3f2fd', border: '1px solid #2f80ac', boxShadow: 'none', p: 0 }}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
          <InfoOutlinedIcon color="primary" sx={{ fontSize: 30 }} />
          <Box>
            <Typography variant="h6" color="primary">
              Your account looks empty
            </Typography>
            <Typography variant="body1">
              Get started by{' '}
              <Link component={RouterLink} to="/contacts/add" underline="hover">
                adding a contact
              </Link>
              {' and '}
              <Link component={RouterLink} to="/campaigns/create" underline="hover">
                creating a new campaign
              </Link>
              .
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default EmptyAccountBanner
